import { maxRegisterApi } from '@/api/maxRegisterApi';

const maxRegister = {
  state: {
    pkgInfo: {},
  },
  getters: {
    getPkgInfo: state => state.pkgInfo,
  },
  mutations: {
    SET_PKG_INFO(state, pkgInfo) {
      state.pkgInfo = pkgInfo;
    },
  },
  actions: {
    getMxwPkgInfo_action({ commit }) {
      return maxRegisterApi.getMxwPkgInfo().then(response => {
        commit('SET_PKG_INFO', response.data);
        return response.data;
      });
    },
  },
};

export default maxRegister;
